import React, { useEffect, useRef, useState } from "react";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import StartSelectMapBox from "./components/StartSelectMapBox";
import EndSelectMapBox from "./components/EndSelectMapBox";
import { Locationdata } from "./components/location";
import { toLngLat } from "../../utils/latLog";

import truck from "./../../components/icons/truck.png";

mapboxgl.accessToken =
  "pk.eyJ1IjoiZGlsZWVwc2tiMzUwIiwiYSI6ImNtOXR4bnRqYTAzcGYyanExOXc2aWZtdnkifQ.mrGKETNvcm876Y6AU__wfA";

const MapBox = () => {
  const mapContainerRef = useRef<HTMLDivElement | null>(null);
  const mapRef = useRef<mapboxgl.Map | null>(null);

  const [start, setStart] = useState<[number, number] | null>(null);
  const [end, setEnd] = useState<[number, number] | null>(null);

  // Initialize map only once
  useEffect(() => {
    if (!mapContainerRef.current) return;

    mapRef.current = new mapboxgl.Map({
      container: mapContainerRef.current,
      style: "mapbox://styles/mapbox/streets-v11",
      center: [78.9629, 20.5937], // India center
      zoom: 3,
    });

    mapRef.current.addControl(new mapboxgl.NavigationControl(), "top-right");

    return () => {
      mapRef.current?.remove();
    };
  }, []);

  let lngLat: [number, number];

  const getStartLoc = ({ name, lat, lng }: any) => {
    lngLat = [lng, lat];
    setStart(lngLat);
    mapRef.current?.flyTo({
      center: lngLat,
      zoom: 12,
      essential: true,
    });
  };

  const getEndLoc = ({ name, lat, lng }: any) => {
    lngLat = [lng, lat];
    setEnd(lngLat);
    mapRef.current?.flyTo({
      center: lngLat,
      zoom: 12,
      essential: true,
    });
  };

  useEffect(() => {
    if (mapRef.current && start && end) {
      const map = mapRef.current;

      const updateRoute = async () => {
        try {
          const query = await fetch(
            `https://api.mapbox.com/directions/v5/mapbox/driving/${start.join(",")};${end.join(",")}?geometries=geojson&access_token=${mapboxgl.accessToken}`,
          );
          const data = await query.json();
          const route = data.routes[0].geometry;

          // Remove previous route source/layer if they exist
          if (map.getLayer("route-line")) map.removeLayer("route-line");
          if (map.getSource("route")) map.removeSource("route");

          map.addSource("route", {
            type: "geojson",
            data: {
              type: "Feature",
              geometry: route,
              properties: {},
            },
          });

          map.addLayer({
            id: "route-line",
            type: "line",
            source: "route",
            layout: {
              "line-join": "round",
              "line-cap": "round",
            },
            paint: {
              "line-color": "#3b82f6",
              "line-width": 6,
            },
          });

          new mapboxgl.Marker().setLngLat(start).addTo(map);
          new mapboxgl.Marker().setLngLat(end).addTo(map);

          map.fitBounds([start, end], {
            padding: 100,
            maxZoom: 14,
            duration: 1000,
          });

          // Add custom truck icon
          // map.loadImage(
          //   "https://cdn-icons-png.flaticon.com/512/1995/1995470.png",
          //   (error, image) => {
          //     if (error || !image) return;
          //     if (!map.hasImage("truck")) {
          //       map.addImage("truck", image);
          //     }

          //     map.addSource("truck-marker", {
          //       type: "geojson",
          //       data: {
          //         type: "FeatureCollection",
          //         features: [
          //           {
          //             type: "Feature",
          //             geometry: {
          //               type: "Point",
          //               coordinates: start,
          //             },
          //             properties: {}, // ✅ add this
          //           },
          //         ],
          //       },
          //     });

          //     map.addLayer({
          //       id: "truck-layer",
          //       type: "symbol",
          //       source: "truck-marker",
          //       layout: {
          //         "icon-image": "truck",
          //         "icon-size": 0.05,
          //       },
          //     });
          //   },
          // );

          // Get user's current location
          // navigator.geolocation.getCurrentPosition(
          //   (position) => {
          //     const { latitude, longitude } = position.coords;
          //     new mapboxgl.Marker({ color: "red" })
          //       .setLngLat([longitude, latitude])
          //       .setPopup(new mapboxgl.Popup().setText("Your Location"))
          //       .addTo(map);
          //   },
          //   (err) => console.warn("Geolocation error:", err),
          //   { enableHighAccuracy: true },
          // );

          // Distance
          const distanceInMeters = data.routes[0].distance;
          const distanceInKm = (distanceInMeters / 1000).toFixed(2);
          const distanceInMiles = (distanceInMeters / 1609.34).toFixed(2);
        } catch (error) {}
      };

      updateRoute();
    }
  }, [start, end]);

  return (
    <>
      <div className="flex gap-5">
        <StartSelectMapBox onSelect={getStartLoc} />
        <EndSelectMapBox onSelect={getEndLoc} />
      </div>
      <div
        ref={mapContainerRef}
        style={{ width: "100%", height: "400px", borderRadius: "8px" }}
      />
    </>
  );
};

export default MapBox;
